export default Object.freeze({
  SCREENED: 'SCREENED',
  PARTIAL_SCREEN: 'PARTIAL_SCREEN',
  CONFLICT: 'CONFLICT',
  UNSCREENED: 'UNSCREENED',
});
